/**
 * Parse multiline / comma-separated province names against Google Ads canonical lists (ES/TH).
 * @param {string} raw
 * @returns {string}
 */
export function normalizeProvinceCompareKey(raw) {
  return String(raw || "")
    .trim()
    .toLowerCase()
    .replace(/\s+province$/i, "")
    .replace(/\s+/g, " ")
    .trim();
}

/**
 * @param {string} raw
 * @param {readonly string[]} provinceList
 * @returns {string|null}
 */
export function resolveProvinceCanonical(raw, provinceList) {
  if (typeof raw !== "string" || !raw.trim()) return null;
  const key = normalizeProvinceCompareKey(raw);
  if (!key) return null;
  const exactLower = new Map(provinceList.map((c) => [String(c).toLowerCase(), c]));
  const direct = exactLower.get(String(raw).trim().toLowerCase());
  if (direct) return direct;
  for (const c of provinceList) {
    if (normalizeProvinceCompareKey(c) === key) return c;
  }
  return null;
}

/**
 * @param {string} text
 * @param {readonly string[]} provinceList
 * @returns {{ counties: string[], unknown: string[] }}
 */
export function parseSpainThailandProvincesText(text, provinceList) {
  if (typeof text !== "string" || !text.trim()) {
    return { counties: [], unknown: [] };
  }
  const parts = text
    .split(/[\n,;]+/)
    .map((s) => s.trim())
    .filter(Boolean);
  const counties = [];
  const unknown = [];
  const seen = new Set();
  for (const p of parts) {
    const canon = resolveProvinceCanonical(p, provinceList);
    if (canon) {
      if (!seen.has(canon)) {
        seen.add(canon);
        counties.push(canon);
      }
    } else {
      unknown.push(p);
    }
  }
  return { counties, unknown };
}
